import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { networkKeys } from "../../samples/queryKeys";
import { UrlReport } from "../@types";
import networkApi from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";
import { removeSurroundingQuotes } from "../util";

const { cloud_enabled: cloudEnabled } = window.tcbase.consts;

export const defaultURLReportQueryOptions = (url: string) => ({
  queryKey: networkKeys.urlReport(url),
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    networkApi.urlReport({ url, signal }),
  select: ({ data }: AxiosResponse<UrlReport>) => data,
  enabled: Boolean(url && cloudEnabled),
  retry: false,
  ...USEQUERY_DISABLE_REFETCH_OPTIONS,
  refetchOnMount: true
});

const useNetworkThreatIntelURLReport = (_url: string) => {
  const url = removeSurroundingQuotes(_url);
  const {
    data: networkRepData,
    error,
    isError,
    isFetching,
    isLoading,
    isSuccess,
    refetch
  } = useQuery<
    AxiosResponse<UrlReport>,
    AxiosResponse<{ message: string; requested_url: string }>,
    UrlReport
  >({
    ...defaultURLReportQueryOptions(url)
  });

  return {
    data: networkRepData,
    isFetching,
    isLoading,
    isSuccess,
    error,
    isError,
    refetch
  };
};
export default useNetworkThreatIntelURLReport;
